/* Proton Partner Hub — partner link tracking (2026-10-23).
   ?pt=CODE (from a partner link) → remember the partner for 30 days, count the click,
   and stamp the cart with partner_code so the order credits the partner even when the code can't apply.
   A /discount/CODE visit (discount_code cookie) is counted as a click too. Fails silent. */
(function () {
  try {
    var HIT = 'https://protonpartner.co/partners/api/hit';
    var ls = window.localStorage, ss = window.sessionStorage;
    var clean = function (c) { return String(c || '').toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 40); };
    var q = new URLSearchParams(location.search);
    var code = clean(q.get('pt')), src = String(q.get('s') || '').slice(0, 40), viaLink = !!code;
    if (!code) {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      if (m) code = clean(decodeURIComponent(m[1]));
    }
    if (!code) return;
    var vid = ls.getItem('ppt_vid');
    if (!vid) { vid = Math.random().toString(36).slice(2) + Date.now().toString(36); ls.setItem('ppt_vid', vid); }
    var seenKey = 'ppt_seen_' + code, last = +ls.getItem(seenKey) || 0;
    if (viaLink || Date.now() - last > 864e5) {
      if (!ss.getItem(seenKey)) {
        ss.setItem(seenKey, '1'); ls.setItem(seenKey, String(Date.now()));
        var payload = JSON.stringify({ c: code, v: vid, s: src, p: location.pathname, r: document.referrer.slice(0, 200) });
        if (navigator.sendBeacon) navigator.sendBeacon(HIT, new Blob([payload], { type: 'text/plain' }));
      }
    }
    if (viaLink) { ls.setItem('ppt_code', code); ls.setItem('ppt_ts', String(Date.now())); }
    var pc = ls.getItem('ppt_code'), pts = +ls.getItem('ppt_ts') || 0;
    if (pc && Date.now() - pts < 30 * 864e5 && ss.getItem('ppt_cart') !== pc) {
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { partner_code: pc } }) }).then(function (r) { if (r.ok) ss.setItem('ppt_cart', pc); }).catch(function () {});
    }
  } catch (e) {}
})();
